export default "__VITE_ASSET__DxBWfIED__"